import React from 'react';
import { Instagram } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="lodge-footer">
      <div className="footer-container">
        <div className="footer-main">
          <div className="footer-brand">
            <h3 className="footer-brand-text">THE LODGE</h3>
          </div>

          <div className="footer-links">
            <a 
              href="https://www.instagram.com/thelodge0711/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="instagram-link"
            >
              <Instagram size={18} strokeWidth={2} />
              <span>@thelodge0711</span>
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © 2026 THE LODGE. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;